import React from "react";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter } from "helpers/string";
import { getCurrency } from "helpers/currency";

import TableCell from "components/Tables/TableCell";

// Склонение слова "день" для русского языка
const pluralizeDays = (count, lang) => {
    if (lang === 'ru') {
        const abs = Math.abs(count);
        const lastTwo = abs % 100;
        const lastOne = abs % 10;

        if (lastTwo >= 11 && lastTwo <= 19) {
            return 'дней';
        }
        if (lastOne === 1) {
            return 'день';
        }
        if (lastOne >= 2 && lastOne <= 4) {
            return 'дня';
        }
        return 'дней';
    }
    // English
    return count === 1 ? 'day' : 'days';
};

export default function BetTableData({ content }) {
    const { t, i18n } = useTranslation();

    const isZeroPrice = content.price === 0 || content.price === "0";

    // Оплата (bank_days) - показываем только если есть значение
    const bankDaysStr = content.bank_days != null
        ? `${t("cargo.allTable.payment")}: ${content.bank_days} ${pluralizeDays(content.bank_days, i18n.language)}`
        : "";

    // Если цена = 0, показываем payment_type первой строкой, "Тип оплаты: payment_rate_type" второй
    if (isZeroPrice) {
        const paymentType = content.payment_type ? capitalizeFirstLetter(content.payment_type.toLowerCase()) : "";
        const paymentRateType = content.payment_rate_type
            ? `${t("cargoFields.rate_section.type_payment")}: ${content.payment_rate_type.toLowerCase()}`
            : "";
        return (
            <TableCell
                title={paymentType}
                description={paymentRateType}
                description2={bankDaysStr}
            />
        );
    }

    // Тип оплаты + тип ставки (для обычного случая)
    const descriptionParts = [];
    if (content.payment_type) {
        descriptionParts.push(content.payment_type);
    }
    if (content.payment_rate_type) {
        descriptionParts.push(content.payment_rate_type);
    }
    const paymentTypeStr = capitalizeFirstLetter(descriptionParts.join(", ").toLowerCase());

    // Строка 1: Цена + НДС
    const priceStr = getCurrency(content.price, content.currency);
    const vatSuffix = content.is_vat_included ? ` ${t("cargoFields.rate_section.vat_included")}` : "";
    const title = priceStr ? `${priceStr}${vatSuffix}` : "";

    return (
        <TableCell
            title={title}
            description={paymentTypeStr}
            description2={bankDaysStr}
        />
    );
}
